/**
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */

import { LookupCollection } from "./BaseCollection";
import { BaseModel } from "./BaseModel";

export class LookupValue extends BaseModel {
    id: number | null = null
    value: any | null = null

    public getClassName(): string {
        return 'lookupValue';
    }
}

export class LookupValueCollection extends LookupCollection<LookupValue> {
    protected modelCls = LookupValue;
    getModelClassName(): string {
        return 'lookupValue'
    }
}
